// services/functions/revokeLicenseSeat.ts — typed wrapper around
// the revokeLicenseSeat callable. The mintReplacementCode flag
// drives the same-tx reissue path on the backend.

import { httpsCallable } from 'firebase/functions';
import { functions } from '@/services/firebase';

interface Input {
  licenseOrgId: string;
  allocationId: string;
  mintReplacementCode?: boolean;
}

interface Output {
  allocationId: string;
  status: 'revoked';
  alreadyRevoked?: boolean;
  replacementCode?: string;
  replacementCodeHash?: string;
  replacementCodeExpiresAt?: string;
}

const callable = httpsCallable<Input, Output>(functions, 'revokeLicenseSeat');

export async function revokeLicenseSeat(input: Input): Promise<Output> {
  const res = await callable(input);
  return res.data;
}
